import React from "react";
import clsx from 'clsx';

import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import withCurrentUser from "../../../hocs/with_current_user.js";
import withShowToast from '../../../hocs/with_show_toast.js';
import { compose } from 'redux';

import {
  Dialog,
  DialogContent,
  Accordion, AccordionDetails,
  AccordionSummary,
  CircularProgress,
  IconButton
} from '@material-ui/core';

import IcClose from "../../../resources/icons/ic_close.js";
import MybilioTextLogoBronze from "../../../resources/logo/mybilio_text_logo_bronze.js";

import I18n from "../../../base/i18n.js";

import { ButtonVariantOutlined } from "../../../base/buttons/constants.js";
import IcEdit from "../../../resources/icons/ic_edit.js";
import Button from "../../../base/buttons/button.js";

import { ProjectModel } from "../../../models/projects/project_model.js";

import styles from "./styles.js";

import PersonalInfoFields  from "../../../base/user_fields/personal_info_fields.js";
import QuestionnaireFields from "../../../base/user_fields/questionnaire_fields.js";
import { IbanMethod }      from "../../../../components/base/user_fields/payment_method_fields.js";

import PaymentMethodSection from "./components/payment_method_section.js";
import ConfirmationSection  from "./components/confirmation_section.js";

import NewInvestmentUseCase           from "../../../use_cases/projects/investments/new_investment_use_case.js";
import ShowLimitInvestmentUseCase     from "../../../use_cases/projects/investments/show_limit_investments_use_case.js";
import ShowInvestmentConfirmationInfo from "../../../use_cases/projects/investments/show_investment_confirmation_info_use_case.js";

import InvestmentPersonalInfoUseCase  from "../../../use_cases/projects/investment_steps/investment_personal_info_use_case.js";
import InvestmentQuestionnaireUseCase from "../../../use_cases/projects/investment_steps/investment_questionnaire_use_case.js";
import InvestmentPaymentMethodUseCase from "../../../use_cases/projects/investment_steps/investment_payment_method_use_case.js";
import InvestmentConfirmationUseCase  from "../../../use_cases/projects/investment_steps/investment_confirmation_use_case.js";

import Analytics from "../../../utils/analytics";

const PersonalInfoStep  = "personal_info";
const QuestionnaireStep = "questionnaire";
const PaymentMethodStep = "payment_method";
const ConfirmationStep  = "confirmation";
const AppliedStep       = "applied";

const ScrollToSectionDelta = 54;

class SubmitInvestment extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      prevState: undefined,
      step: undefined,
      allAccepted: false,
      formLoaded: false,
      limitForInvestmentAmount: "",
      confirmationInfo: [],
      isFirstLoad: true,
      title: props.currentUser.personalInfo.title
    };

    this.project = props.project;

    this.nominalInvestmentAmount = parseInt(props.nominalInvestmentAmount);
    this.minInvestmentAmount     = parseFloat(this.project.minInvestmentAmount || this.nominalInvestmentAmount)

    this.investmentAmountStepsMinCount = Math.ceil(this.minInvestmentAmount / this.nominalInvestmentAmount);
    this.investmentAmountStepsCount    = 0;

    this.investment = {};

    this.sections = {
      [PersonalInfoStep]: {
        title: I18n.t("web.modal.submit_investment.personal_info.title"),
        content: this.personalInfoContent
      },
      [QuestionnaireStep]: {
        title: I18n.t("web.modal.submit_investment.questionnaire.title"),
        content: this.questionnaireContent
      },
      [PaymentMethodStep]: {
        title: I18n.t("web.modal.submit_investment.payment_method.title"),
        content: this.paymentMethodContent
      },
      [ConfirmationStep]: {
        title: I18n.t("web.modal.submit_investment.confirmation.title"),
        content: this.confirmationContent
      }
    }

    this.passedSteps = {

    }

    this.sectionRefs = {

    }

    this.sectionAnchorsRefs = {

    }

    this.sectionsTopOffset = {

    }
  }

  componentDidMount() {
    NewInvestmentUseCase.execute(this.project.id)
    .then((result) => {
      const { data: { investment, allowInlineProfileEditing } } = result;

      this.updateFormData(investment);

      this.setState({
        allowInlineProfileEditing: allowInlineProfileEditing,
        amount: this.investment.amount,
        step: this.investment.status
      })
      this.fetchAdditionalInfo()
    })
    .catch((result) => {
      this.setState({
        formLoaded: true
      })
      this.props.showServerErrorIfNeed(result);
    })
  }

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      open: props.open
    }
  }

  componentDidUpdate(_, prevState) {
    if(Object.keys(this.sectionsTopOffset).length === 0) {
      Object.keys(this.sectionAnchorsRefs).forEach((key) => {
        const section = this.sectionAnchorsRefs[key];
        this.sectionsTopOffset[key] = section
      })
    }
    if(this.state.errorData && !prevState.errorData) {
      const { step, errorData } = this.state;
      const { fields: { amount } = {},
              paymentMethod,
              signature,
              participant: {
                user: { personalInfo, questionnaire } = {},
              } = {}
            } = errorData || {};
      let stepToScroll;
      if(personalInfo) {
        stepToScroll = PersonalInfoStep
      }
      else if(questionnaire) {
        stepToScroll = QuestionnaireStep;
      }
      else if(paymentMethod || amount) {
        stepToScroll = PaymentMethodStep;
      }
      else if(signature) {
        stepToScroll = ConfirmationStep;
      }

      if(stepToScroll) {
        if(step !== stepToScroll) {
          this.onNextStep(stepToScroll);
        }
      }
    }
    if(prevState.step !== this.state.step) {
      this.trackStepChange();
    }
    if(this.state.isFirstLoad && this.state.formLoaded) {
      this.scrollToSection(this.state.step);
      this.setState({
        isFirstLoad: false
      })
    }
  }

  fetchAdditionalInfo = () => {
    ShowLimitInvestmentUseCase.execute(this.investment)
    .then(result => {
      this.setState({
        limitForInvestmentAmount: parseFloat(result.data.limitForInvestment)
      })
      ShowInvestmentConfirmationInfo.execute(this.investment)
      .then(result => {
        this.setState({
          formLoaded: true,
          confirmationInfo: result.data.confirmationInfo || []
        })
      })
      .catch((result) => {
        this.setState({
          formLoaded: true
        })
        this.props.showErrorMessage(result);
      })

    })
    .catch((result) => {
      this.setState({
        formLoaded: true
      })
      this.props.showErrorMessage(result);
    })
  }

  // Personal info
  personalInfoContent = () => {
    const { classes } = this.props;

    const { submit, allowInlineProfileEditing, errorData } = this.state;
    const { participant: { user: { personalInfo: personalInfoErrors } = {} } = {} } = errorData || {};

    const { participant: { user: { personalInfo = {} } = {} } } = this.investment;

    return <div className = { classes.personalInfo } >
      {
        !allowInlineProfileEditing &&
        <div className = { classes.editProfileRow } >
          <Button className = { classes.editProfile }
                  variant = { ButtonVariantOutlined }
                  onClick = { this.onEditProfile } >
            <IcEdit className = { classes.editProfileIcon } />
            <span>
              { I18n.t("action.edit") }
            </span>
          </Button>
        </div>
      }
      <PersonalInfoFields item = { personalInfo }
                          onChange = { this.onProfileChanged }
                          readOnly = { !allowInlineProfileEditing }
                          errorData = { personalInfoErrors }
                          scrollToElement = { this.scrollToPersonalInfoField }/>
      <div className = { classes.buttonContainer } >
        <Button disabled = { submit }
                type = { "submit" }
                className = { classes.button } >
          { I18n.t("action.next") }
        </Button>
      </div>
    </div>
  }

  onEditProfile = () => {
    this.setState({
      allowInlineProfileEditing: true
    })
  }

  onProfileChanged = (personalInfo) => {
    this.investment.participant.user.personalInfo = personalInfo;
    this.passedSteps[PersonalInfoStep] = false;
    this.passedSteps[QuestionnaireStep] = false;
    this.passedSteps[PaymentMethodStep] = false;
    this.passedSteps[ConfirmationStep] = false;

    this.currentStep = PersonalInfoStep;
  }

  // Questionnaire
  questionnaireContent = () => {
    const { classes } = this.props;

    const { submit, errorData } = this.state;
    const { participant: { user: { questionnaire: questionnaireErrors } = {} } = {} } = errorData || {};

    const { participant: { user: { questionnaire: { data: questions } } } } = this.investment;

    return <div className = { clsx({
      [classes.questionnaire]: true,
    })}>
      <QuestionnaireFields onChange = { this.onQuestionnaireChanged }
                           questions = { questions }
                           showDisclaimer = { true }
                           errorData = { questionnaireErrors } />
      <div className = { classes.buttonContainer } >
        <Button disabled = { submit }
                className = { classes.button }
                type = { "submit" } >
          { I18n.t("action.next") }
        </Button>
      </div>
    </div>
  }

  onQuestionnaireChanged = (questions) => {
    this.investment.participant.user.questionnaire.data = questions;
    this.passedSteps[QuestionnaireStep] = false;
    this.passedSteps[PaymentMethodStep] = false;
    this.passedSteps[ConfirmationStep] = false;

    this.currentStep = QuestionnaireStep;
    this.fetchAdditionalInfo()
  }

  // Payment method
  paymentMethodContent = () => {
    const { submit, limitForInvestmentAmount, amount, title } = this.state;
    const { errorData } = this.state;
    const {
      paymentMethod: paymentMethodErrors,
      fields: { amount: amountErrors } = {}
    } = errorData || {};
    const { classes } = this.props;

    return <div className = { clsx({
      [classes.bankData]: true,
    })}>
      <PaymentMethodSection minStepsCount = { this.investmentAmountStepsMinCount }
                            stepsCount = { this.investmentAmountStepsCount }
                            amount = { amount }
                            title = { title }
                            paymentMethod = { this.investment.paymentMethod }
                            nominalInvestmentAmount = { this.nominalInvestmentAmount }
                            minInvestmentAmount = { this.minInvestmentAmount }
                            limitForInvestmentAmount = { limitForInvestmentAmount }
                            onChangeStepsCount = { this.onChangeStepsCount }
                            onChangePaymentMethod = { this.onChangePaymentMethod }
                            amountErrors = { amountErrors }
                            paymentMethodErrors = { paymentMethodErrors } />
      <div className = { classes.buttonContainer } >
        <Button disabled = { submit }
                type = { "submit" }
                className = { classes.button } >
          { I18n.t("action.next") }
        </Button>
      </div>
    </div>
  }

  onChangeStepsCount = (count) => {
    this.investmentAmountStepsCount = count;
    this.investment.amount = this.nominalInvestmentAmount * this.investmentAmountStepsCount;
    this.setState({
      amount: this.investment.amount
    })

    this.fetchAdditionalInfo();

    this.passedSteps[PaymentMethodStep] = false;
    this.passedSteps[ConfirmationStep] = false;

    this.currentStep = PaymentMethodStep;
  }

  onChangePaymentMethod = (paymentMethod) => {
    this.investment.paymentMethod = paymentMethod;
    this.passedSteps[PaymentMethodStep] = false;
    this.passedSteps[ConfirmationStep] = false;

    this.currentStep = PaymentMethodStep;
  }

  // Confirmation
  confirmationContent = () => {
    const { classes } = this.props;

    const { submit, errorData, confirmationInfo } = this.state;
    const { signature: signatureErrors } = errorData || {};

    return <div className = { clsx({
      [classes.overview]: true,
    })}>
      <ConfirmationSection project = { this.project }
                investment = { this.investment }
                signature = { this.investment.signature }
                confirmationInfo = { confirmationInfo }
                onChangeConfirmationInfo = { this.onChangeConfirmationInfo }
                onChangeSignature = { this.onChangeSignature }
                signatureErrors = { signatureErrors } />
      <div className = { classes.buttonContainer } >
        <Button disabled = { submit || !this.isAllChecked() }
                type = { "submit" }
                className = { classes.button } >
          { I18n.t("action.invest_now") }
        </Button>
      </div>
    </div>
  }

  onChangeConfirmationInfo = (newConfirmationInfo) => {
    this.setState({
      confirmationInfo: newConfirmationInfo
    })
  }

  onChangeSignature = (newSignature) => {
    this.investment.signature = newSignature;
  }

  onNextStep = (nextStep) => {
    const { step } = this.state;
    if(step === nextStep) {
      this.setState({
        prevStep: step,
        step: undefined
      });
      return;
    }

    if(this.currentStep !== nextStep && !this.passedSteps[nextStep]) {

      if(!step) {
        this.setState({
          prevStep: undefined,
          step: this.currentStep
        });
        this.scrollToSection(this.currentStep);
      }
      this.props.showWarningMessage(I18n.t("web.modal.submit_investment.next_step_alert"));
      return;
    }
    this.setState({
      prevStep: step,
      step: nextStep
    });
    this.scrollToSection(nextStep);
  }

  scrollToPersonalInfoField = (element) => {
    this.elementToScroll = element;
    this.scrollToField();
  }

  scrollToSection = (sectionId) => {
    if(this.elementToScroll) {
      return;
    }
    const section = this.sectionsTopOffset[sectionId];
    this.dialogBody.scroll({
      top: this.accordionContainer.offsetTop + section.offsetTop - ScrollToSectionDelta,
      left: 0,
      behavior: 'auto'
    });
  }

  scrollToField = () => {
    if(!this.elementToScroll) {
      return;
    }
    this.dialogBody.scroll({
      top: this.elementToScroll.offsetTop,
      left: 0,
      behavior: 'auto'
    });
    this.elementToScroll = undefined;
  }

  updateFormData = (investment) => {
    this.investment = {
      ...investment
    }

    this.fillPassedSteps();
    this.fillAmountIfNeed();
  }

  fillPassedSteps = () => {
    const { status } = this.investment;
    this.currentStep = status;
    if(status === QuestionnaireStep) {
      this.passedSteps[PersonalInfoStep] = true;
    }
    if(status === PaymentMethodStep) {
      this.passedSteps[PersonalInfoStep] = true;
      this.passedSteps[QuestionnaireStep] = true;
    }
    if(status === ConfirmationStep) {
      this.passedSteps[PersonalInfoStep] = true;
      this.passedSteps[QuestionnaireStep] = true;
      this.passedSteps[PaymentMethodStep] = true;
    }
  }

  fillAmountIfNeed = () => {
    if(this.investment.amount === undefined || this.investment.amount === null) {
      this.investment.amount = this.nominalInvestmentAmount * this.investmentAmountStepsMinCount;
      this.investmentAmountStepsCount = this.investmentAmountStepsMinCount;
    }
    else {
      this.investmentAmountStepsCount = this.investment.amount / this.nominalInvestmentAmount;
    }
  }

  isAllChecked = () => {
    const { confirmationInfo } = this.state;
    return (confirmationInfo.filter(info =>  info.type === "checkbox" && info.isRequired) || [])
                            .map(info => info.value || false)
                            .reduce((total, current) => total && current);
  }

  onSubmit = (event) => {
    event.preventDefault();

    const { step } = this.state;

    let useCase;
    if(step === PersonalInfoStep) {
      useCase = InvestmentPersonalInfoUseCase.execute(this.investment);
    }
    else if(step === QuestionnaireStep) {
      useCase = InvestmentQuestionnaireUseCase.execute(this.investment);
    }
    else if(step === PaymentMethodStep) {
      useCase = InvestmentPaymentMethodUseCase.execute(this.investment);
    }
    else if(step === ConfirmationStep) {
      useCase = InvestmentConfirmationUseCase.execute(this.investment);
    }

    this.setState({
      submit: true,
      errorData: undefined
    })

    useCase.then((result) => {
      const { data: { investment } } = result;

      this.updateFormData(investment);

      this.setState({
        submit: false
      });

      const { status: nextStep } = this.investment;
      if(nextStep === AppliedStep) {
        const { onSave, close } = this.props;
        if(onSave) {
          onSave(investment);
        }
        close();
        Analytics.investmentSuccessfullyCreated(this.investment);
        return;
      }
      this.currentStep = nextStep;

      this.onNextStep(nextStep);
    })
    .catch((result) => {
      const { errorData, message } = result;
      this.setState({
        errorData: errorData,
        submit: false
      })
      this.props.showServerErrorIfNeed(message);
    })
  }

  onClose = () => {
    const { onClose } = this.props;
    const { submit } = this.state;
    if(!submit) {
      onClose()
    }
  }

  trackStepChange = () => {
    const { step } = this.state;
    if(!step) {
      return;
    }
    if(step === PersonalInfoStep) {
      Analytics.investmentAtPersonalInfoStep(this.investment);
    }
    if(step === QuestionnaireStep) {
      Analytics.investmentAtQuestionnaireStep(this.investment);
    }
    if(step === PaymentMethodStep) {
      Analytics.investmentAtPaymentMethodStep(this.investment);
    }
    if(step === ConfirmationStep) {
      Analytics.investmentAtConfirmationStep(this.investment);
    }
  }

  render() {
    const { classes, close } = this.props;

    const { open, step, formLoaded } = this.state;

    return <Dialog open = { open }
                   onClose = { this.onClose }
                   scroll = { "body" }
                   className = { classes.root }
                   fullScreen = { true }
                   PaperProps = { {
                    ref: (ref) => { this.dialogBody = ref }
                   } } >
    <IconButton className = { classes.close }
                onClick = { close } >
      <IcClose />
    </IconButton>
    <div className = { classes.titleContainer }>
      <MybilioTextLogoBronze className = { classes.titleLogo }/>
    </div>
    <form onSubmit = { this.onSubmit } >
      <DialogContent className = { classes.content }  >
        <div className = { classes.intro } >
          { I18n.t("web.modal.submit_investment.intro", { project: ProjectModel.displayValue(this.project) }) }
        </div>
        {
          !formLoaded && <CircularProgress className = { classes.loader }/>
        }
        <div className = { classes.accordionContainer }
             ref = { ref => this.accordionContainer = ref } >
          <div className = { classes.accordionAnchors } >
            {
              Object.keys(this.sections).map((key, index) => {
                const section = this.sections[key];
                return <Accordion expanded = { false }
                                       className = { classes.section }
                                       key = { key }
                                       ref = { ref => this.sectionAnchorsRefs[key] = ref } >
                  <AccordionSummary className = { classes.sectionTitle } >
                    <div className = { classes.sectionTitleContent }>
                      <div className = { clsx({
                        [classes.sectionNumber]: true,
                        [classes.current]: step === key
                      }) } >
                        { index + 1 }
                      </div>
                      <div className = { classes.sectionName } >
                        { section.title }
                      </div>
                    </div>
                  </AccordionSummary>
                </Accordion>
              })
            }
          </div>
          <div className = { classes.accordion } >
            {
              formLoaded &&
              Object.keys(this.sections).map((key, index) => {
                const section = this.sections[key];
                return <Accordion expanded = { step === key }
                                      onChange = { () => this.onNextStep(key) }
                                      className = { clsx({
                                        [classes.section]: true
                                      }) }
                                      key = { key }
                                      ref = { ref => this.sectionRefs[key] = ref }
                                      TransitionProps = { {
                                        onEntered: () => {
                                          if(this.elementToScroll) {
                                            this.scrollToField();
                                          }
                                        },
                                        timeout: this.elementToScroll ? 0 : "auto"
                                      } } >
                  <AccordionSummary className = { classes.sectionTitle } >
                    <div className = { classes.sectionTitleContent }>
                      <div className = { clsx({
                        [classes.sectionNumber]: true,
                        [classes.current]: step === key
                      }) } >
                        { index + 1 }
                      </div>
                      <div className = { classes.sectionName } >
                        { section.title }
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails className = { classes.sectionContent } >
                    { section.content() }
                  </AccordionDetails>
                </Accordion>
              })
            }
          </div>
        </div>
      </DialogContent>
    </form>
  </Dialog>
  }
}

export default compose(
  withRouter,
  withShowToast,
  withCurrentUser,
  withStyles(styles)
)(SubmitInvestment);
